import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './input.css';
export default function Input() {
    const [EmailState, setEmailState] = useState({});
    const navigate = useNavigate();
    const [Email, setEmail] = useState('');

         const inputSubmit = event => {
            setEmailState({ ...EmailState, [event.target.name]: event.target.value });
            setEmail(event.target.value);
        }
        const clickHandler = (function(event)  {
            event.preventDefault();
            const config = {
                SecureToken: '80b6bc49-06fb-4361-8853-cefec99aace5',
                To : 'ash@yopmail.com',
                From : EmailState.email,
                Subject : "Thanks for subscribing!",
                Body : `A confirmation email has been sent to <strong>ash@yopmail.com</strong>. Please open it and click the button inside to confirm your subscription.`
            };

            if (!Email)
                alert('Email is empty');
            else {
                if (window.Email) {
                    window.Email.send(config).then(() => navigate('success-page'));
                }           
            }
        });
    return (
        <div id="Inputs">
            <form onSubmit={clickHandler}>
                <label>
                    Email address
                </label>
                <br></br>
                <input name="email" type="email" placeholder="email@company.com" onChange={inputSubmit}/>
                <br></br>
                <button type="submit">Subscribe to monthly newsletter</button>
            </form>
        </div>
    );
}